/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, April 13th 2022, 12:54:47 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { OSActionButton, EmptyStateActionWrapper, useToggleState, Image } from "ui-widgets";
import { NewDocumentTaskTemplateForm } from "service-builder/components/workflow-builder/NewDocumentTaskTemplateForm";

export const EmptyDocumentTemplatesCTA = () => {
  const { handleClose, handleOpen, open } = useToggleState();

  return (
    <>
      <EmptyStateActionWrapper
        title="No document templates are available for this service"
        description="Add a document template by creating a document generation task in this workflow."
        illustrationGraphic={<Image className="image-style-A" src="/img/document-accepted.png" alt="Onestop Admin" />}
      >
        <OSActionButton variant="contained" size="large" onClick={handleOpen}>
          Create Document Generation Task
        </OSActionButton>
      </EmptyStateActionWrapper>
      <NewDocumentTaskTemplateForm open={open} handleClose={handleClose} />
    </>
  );
};
